import { createGlobalStyle } from 'styled-components';
import { PROJECT_THEME } from './theme';

export const AppGlobalStyle = createGlobalStyle`
  :root {
    --LIGHT_GREY: ${PROJECT_THEME.colour.LIGHT_GREY};
    --DARK_GREY: ${PROJECT_THEME.colour.DARK_GREY};
    --COLOUR_LIGHT: ${PROJECT_THEME.colour.COLOUR_LIGHT};
    --COLOUR_MID_LIGHT: ${PROJECT_THEME.colour.COLOUR_MID_LIGHT};
    --COLOUR_MID: ${PROJECT_THEME.colour.COLOUR_MID};
    --COLOUR_MID_DARK: ${PROJECT_THEME.colour.COLOUR_MID_DARK};
    --COLOUR_DARK: ${PROJECT_THEME.colour.COLOUR_DARK};
    --OFF_WHITE: ${PROJECT_THEME.colour.OFF_WHITE};
    --FONT_JETBRAINS_MONO: ${PROJECT_THEME.font.FONT_MONO_JETBRAINS};
    --FONT_SANS_RED_HAT_DISPLAY: ${PROJECT_THEME.font.FONT_SANS_RED_HAT_DISPLAY};
    --FONT_SERIF_ROBOTO_SLAB: ${PROJECT_THEME.font.FONT_SERIF_ROBOTO_SLAB};
    --FONT_SERIF_ROBOTO_SERIF: ${PROJECT_THEME.font.FONT_SERIF_ROBOTO_SERIF};
  }

  html {
    background-color: ${({ theme }) => theme.colour.DARK_GREY};
    /* Tracks the viewport, not the physical screen: 1vw matches the previous
       screen-derived size on a full-width desktop window, while the floor keeps
       rem-based layout legible on phones instead of collapsing to ~4px. */
    font-size: clamp(15px, 1vw, 20px);
    font-family: ${({ theme }) => theme.font.FONT_SANS_RED_HAT_DISPLAY};
    color: ${({ theme }) => theme.colour.OFF_WHITE};
  }

  body,
  #root {
    background-color: ${({ theme }) => theme.colour.DARK_GREY};
    color: ${({ theme }) => theme.colour.OFF_WHITE};
  }

  body {
    margin: 0;
  }
`;
